import classes from "./Loading.module.css";

const Loading = () => {
  return (
    <div className={classes["loader-container"]}>
      <div className={classes["loading-item"]}>
        <h5>Loading...</h5>
        <div className={classes.spinner}></div>
      </div>
    </div>
  );
};

export default Loading;
